import { Theme, createStyles } from '@material-ui/core';

const bulkReportOperation = (theme: Theme) =>
    createStyles({
        pageHeadingRow: {
            display: 'flex',
            alignItems: 'center',
        },
        pageHeading: {
            color: '#333333',
            fontSize: '30px',
            textAlign: 'left',
            fontWeight: 600,
            margin: 0,
            '& img': {
                cursor: 'pointer',
                marginRight: '15px',
            }
        },
        pageTitle: {
            fontSize: 30,
            fontWeight: 600,
            color: '#333333',
            textAlign: 'center',
        },
        paginationBlock: {
            marginLeft: 'auto',
        },
        textRight: {
            textAlign: 'right',
        },
        tableContainer: {
            width: '100%',
            marginTop: theme.spacing.unit * 3,
            overflowX: 'auto',
        },
        table: {
            minWidth: 700,
        },
        row: {
            '&:nth-of-type(odd)': {
                backgroundColor: theme.palette.background.default,
            },
            '& th': {
                padding: '4px 40px 4px 30px',
            },
            '& td': {
                padding: '10px 40px 10px 30px',
            }
        },
        bulkReportrow: {
            '& th': {
                padding: '4px 40px 4px 25px',
            },
            '& td': {
                padding: '10px 40px 10px 25px',
            },
            "& thead": {
                '& th': {
                    padding: '4px 52px 4px 24px',
                },
            }
        },
        red: {
            color: '#F23C3C!important'
        },
        darkYellow: {
            color: '#FB9E2E!important'
        },
        yellow: {
            color: '#FFD016!important'
        },
        green: {
            color: '#30BE76!important'
        },
    })


export default bulkReportOperation;